import Vue from 'vue';
import { Component, Prop, PropSync } from 'vue-property-decorator';
import { getLangProperty } from '@appbase/util';


interface linkObj {
    param: string,
    type: string,
    linkName: string
}

@Component({
})

export default class OpenWindowField extends Vue {
    @Prop ({ type: String }) displayName!: string;
    @Prop({ type: String }) fieldValue!: string; 


    includeLink:boolean = true
    moveTo:string = ""
    nameVal: string=""

    created(){
        if(this.fieldValue.includes('https')){
            this.moveTo = this.fieldValue
            this.nameVal = this.fieldValue
        }
        else{
            this.includeLink = false;
            const host = window.location.origin;
            let link = ""
            let obj:linkObj|null;
            try{
                obj = JSON.parse(this.fieldValue);
            }
            catch{
                obj =null;
            }
            if(obj && obj.type=='wf'){
                link = `${host}/workflow/page/form?${obj.param}&storekey=${new Date().getTime()}`
                this.nameVal = obj.linkName
            }
            this.moveTo = link;
        }
    }

    moveToLink(){
        if(this.moveTo=='') return
        window.open(this.moveTo)
    }

}